import { useCallback, useContext, useMemo } from "react"
import { xml } from "@xmpp/client"
import { v4 as uuid } from "uuid"
import { useFeatureFlagEnabled } from "posthog-js/react"
import { XmppContext } from "@/stream/xmppClient"
import { useAppDispatch, useAppSelector, useAppStore } from "@/reducers/hooks"
import { selectDriverRouteAndLocationDetailsMap } from "@/reducers/accountChatsSelectors"
import { sendGroupchatStanza } from "@/reducers/chatsSliceThunks"
import { buildQuestionContext } from "./fleetTodayCopy"

export type AskSlickAI = (question: string) => Promise<void>

export const FLEET_TODAY_FLAG = "fleet-today-strip"

export const useFleetTodayGate = () =>
  Boolean(useFeatureFlagEnabled(FLEET_TODAY_FLAG))

export function useFleetQuestionContext() {
  const driverMap = useAppSelector(selectDriverRouteAndLocationDetailsMap)
  return useMemo(
    () => buildQuestionContext(Object.values(driverMap)),
    [driverMap],
  )
}

export function useAskSlickAI(
  agentJid: string | undefined,
  onOpenAgent: () => Promise<void> | void,
): AskSlickAI {
  const { client } = useContext(XmppContext)
  const dispatch = useAppDispatch()
  const store = useAppStore()

  return useCallback(
    async (question) => {
      if (!client || !agentJid) return
      await onOpenAgent()
      const myJid = client.jid!.toString()
      const stanza = xml(
        "message",
        { type: "groupchat", to: agentJid, from: myJid, id: uuid() },
        xml("body", {}, question),
        xml("markable", "urn:xmpp:chat-markers:0"),
      )
      sendGroupchatStanza(client, dispatch, stanza, store.getState)
    },
    [client, agentJid, onOpenAgent, dispatch, store],
  )
}
